<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :xl="8" :lg="8" :md="8" :sm="24">
            <a-form-item label="工人类别">
              <a-select
                showSearch
                style="width:274px;"
                placeholder="请选择工人类别"
                :filterOption="filterOption"
                v-model="queryParam.typeId"
                :options="sxWorkerTypeList"
                @select="selectChange"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="姓名">
              <a-input placeholder="请输入姓名" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam.name = '',queryParam.typeId = undefined}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button
        @click="$refs.attendWorkerAddOrUpdate.init('','add')"
        icon="plus"
        type="primary"
        v-action="'attend:worker-form:add'"
      >新建</a-button>
    </div>
    <s-table
      bordered
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
    </s-table>
    <attendWorker-add-or-update
      @ok="queryPage"
      ref="attendWorkerAddOrUpdate"
    />
  </a-card>
</template>

<script>
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, delObj } from '@/api/common/AttendWorker'
import { dropSxWorkerTypeList } from '@/api/common/SxWorkerType'
import attendWorkerAddOrUpdate from './AttendWorkerAddOrUpdate'
import { enterEvent } from '@/utils/util'
import Tooltip from 'ant-design-vue/es/vc-tooltip/Tooltip'
export default {
  name: 'AttendWorkerView',
  mixins: [TableMixin],
  components: {
    Tooltip,
    attendWorkerAddOrUpdate
  },
  data () {
    return {
      description: '人员增/减是用来管理管理工人的，增减工人和关联或解除考勤小组',
      queryParam: {
        name: '',
        typeId: undefined
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      sxWorkerTypeList: [],
      columns: [
        {
          title: '序号',
          width: '80px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        // {
        //   title: '主键',
        //   dataIndex: 'id'
        // },
        {
          title: '姓名',
          dataIndex: 'name'
        },
        {
          title: '性别',
          dataIndex: 'sex',
          customRender: (sex) => {
            return sex === '1' ? '男' : '女'
          }
        },
        {
          title: '身份证号',
          dataIndex: 'idNumber'
        },
        {
          title: '工人类别',
          // dataIndex: 'typeId'
          dataIndex: 'typeIdName'
        },
        {
          title: '考勤小组',
          width: '200px',
          dataIndex: 'groups',
          customRender: (text) => {
            return (
              <div>
                {
                  text
                }
              </div>
            )
          }
        },
        {
          title: '操作',
          align: 'center',
          width: '250px',
          customRender: (record) => {
            return (
              <div>
                <span v-action="attend:worker-form:show">
                  <a onClick={(e) => this.show(record)}>查看</a>
                </span>
                <span v-action="attend:worker-form:edit">
                  <a-divider type="vertical" />
                  <a onClick={(e) => this.edit(record)}>修改</a>
                </span>
                <span v-action="attend:worker-form:del">
                  <a-divider type="vertical" />
                  <a-popconfirm title="是否删除" onConfirm={() => this.deleteItem(record)} okText="是" cancelText="否">
                    <a-icon slot="icon" type="question-circle-o" style="color: red" />
                    <a href="javascript:;" style="color: red">删除</a>
                  </a-popconfirm>
                </span>
                <span v-action="attend:worker-form:link">
                  <a-divider type="vertical" />
                  <a-tooltip title="工人关联考勤小组">
                    <a onClick={(e) => this.link(record)}>关联</a>
                  </a-tooltip>
                </span>
                <span v-action="attend:worker-form:remove">
                  <a-divider type="vertical" />
                  <a-tooltip title="解除工人和考勤小组的关联" placement="topRight">
                    <a onClick={(e) => this.removeLink(record)} style="color: red">解除</a>
                  </a-tooltip>
                </span>
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    show (record) {
      this.$refs.attendWorkerAddOrUpdate.init(record.id, 'show')
    },
    edit (record) {
      this.$refs.attendWorkerAddOrUpdate.init(record.id, 'edit')
    },
    link (record) {
      this.$refs.attendWorkerAddOrUpdate.init(record.id, 'link')
    },
    deleteItem (record) {
      delObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    removeLink (record) {
      this.$refs.attendWorkerAddOrUpdate.init(record.id, 'removeLink')
    },
    // 点击选择框时触发
    selectChange (e) {
      if (e != null) {
        this.queryParam.typeId = e
      }
      this.queryPage()
    }
  },
  mounted () {
    dropSxWorkerTypeList().then(res => {
      this.sxWorkerTypeList = res.data
    })
    enterEvent(this.queryPage)
  }
}
</script>

<style scoped>

</style>
